import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {MedicalReportExtended, MedicalReportSmall} from '@/features/medical-reports/types'
import {httpGetMedicalReport} from '@/features/medical-reports/http/medicalReports.http'
import {ResponseType} from '@/types'

type MedicalReportResponse<T extends ResponseType> = T extends 'extended' ? MedicalReportExtended : MedicalReportSmall

export const useGetMedicalReport = <T extends ResponseType>({
    urlParams,
    params,
    options
}: {
    urlParams: {
        medicalReportId: string
    }
    params?: {
        responseType?: T
    }
    options?: Omit<UseQueryOptions<MedicalReportResponse<T>>, 'queryKey' | 'queryFn'>
}) =>
    useQuery({
        queryKey: [QUERY_KEYS.MEDICAL_REPORTS, urlParams, params],
        queryFn: () =>
            httpGetMedicalReport({
                urlParams,
                params: {responseType: params?.responseType ?? 'extended'}
            }),
        ...options
    })
